<a [routerLink]="{ cxRoute: 'product', params: entry().product } | cxUrl" tabindex="-1">
  <sd-media class="image" [container]="entry().product?.images?.PRIMARY"></sd-media>

  @if (!isTabletMdDown()) {
    <div class="add-wishlist" (click)="$event.preventDefault(); $event.stopPropagation()">
      <sd-cart-wishlist-button [productCode]="entry().product?.code"></sd-cart-wishlist-button>
    </div>
  }
</a>
